import React, { useState, useContext } from 'react';
import { Button, Dropdown, Form, message, notification, Tooltip, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { isValidValue } from '../../../common/helper';
import { MCPResearchContext } from '../MCPResearchUI';
import CciCloud from '../../../common/components/CciCloud/CciCloud';
import { MCPAppCompletionStatus } from '../../../common/constants';
import { updateMCPServerCompletionStatus } from '../MCPServerApis';
import ErrorMessageTemplate from './BasicDetails/ErrorMessageTemplate';
import { getAppStatus } from '../MCPServerHelper';

const { Text } = Typography;

const PageHeader = () => {
    const { id, mcpAppDetails, saving } = useContext(MCPResearchContext);
    const { basicDetails, mcpResearchData } = mcpAppDetails;
    const [completionStatus, setCompletionStatus] = useState(
        isValidValue(mcpResearchData?.completion_status) ? mcpResearchData.completion_status : 'Status'
    );

    const [changingStatus, setChangingStatus] = useState(false);

    const onCompletionStatusSelect = async (item) => {
        setChangingStatus(true);
        await updateMCPServerCompletionStatus(id, item.key)
            .then((res) => {
                console.log('completionStatus api res :', res);
                if (res.success === 1) {
                    message.success('Completion Status Updated Successfully');
                    setCompletionStatus(item.key);
                    return;
                } else {
                    if (Object.hasOwn(res, 'data') && res.data.length > 0) {
                        notification.error({
                            message: 'Completion Status Update Failed',
                            description: <ErrorMessageTemplate errors={res.data} />,
                            duration: 0,
                            style: {
                                width: 600,
                            },
                        });
                    } else {
                        message.error(res?.message ?? 'Failed to update Completion Status');
                    }
                }
                setChangingStatus(false);
            })
            .catch((err) => {
                setChangingStatus(false);
                message.error(err.message ?? 'Failed to update Completion Status');
            })
            .finally(() => {
                setChangingStatus(false);
            });
    };

    return (
        <div className='container ns-flex ns-flex_space-between'>
            <div className='ns-flex gap-[10%] ns-width-full'>
                <Text className='ns-flex ns-flex_centered'>
                    <label style={{ fontWeight: 'bold', marginRight: 2 }}>App Name:</label>
                    <Tooltip title={basicDetails.name}>{basicDetails.display_name}</Tooltip>
                </Text>
                <Text className='ns-flex ns-flex_centered'>
                    <label style={{ fontWeight: 'bold', marginRight: 2 }}>Classification:</label>
                    {basicDetails.classification}
                </Text>
                <CciCloud cci={basicDetails.cci} showLabel={true} />
            </div>
            <div className='ns-flex ns-flex_centered ns-flex_gap'>
                <Dropdown.Button
                    menu={{ items: Object.values(MCPAppCompletionStatus), onClick: onCompletionStatusSelect }}
                    icon={<DownOutlined />}
                    loading={changingStatus}
                >
                    {getAppStatus(completionStatus)}
                </Dropdown.Button>
                <Form.Item style={{ margin: 'auto' }}>
                    <Button key='1' type='primary' htmlType='submit' loading={saving}>
                        Save
                    </Button>
                </Form.Item>
            </div>
        </div>
    );
};

export default PageHeader;
